<template>
  <b-form
    v-if="show"
    @submit="onSubmit">
    <b-form-group
      id="input-group-internal-name"
      label="Nom interne"
      label-for="input-internal-name">
      <b-form-input
        id="input-internal-name"
        v-model="form.esta_internal_name"
        type="text"
        required
      />
    </b-form-group>

    <b-form-group
      id="input-group-name"
      label="Login de l'établissement"
      label-for="input-name">
      <b-form-input
        id="input-internal-name"
        v-model="form.esta_name"
        type="text"
        required
      />
    </b-form-group>
    <b-form-group
      id="input-group-nice-name"
      label="Nom d'affichage de l'établissement"
      label-for="input-nice-name">
      <b-form-input
        id="input-nice-name"
        v-model="form.esta_nice_name"
        type="text"
        required
      />
    </b-form-group>

    <b-form-group
      id="input-group-tags"
      label="Tags de l'établissement"
      label-for="input-tags">
      <b-form-select
        v-model="form.tags"
        :options="options"
        multiple/>
    </b-form-group>

    <b-form-group
      id="input-group-relativeto"
      label="Établissement parent"
      label-for="input-relativeto">
      <b-form-select
        id="input-relativeto"
        v-model="form.parent_id"
        :options="establishments"
      />
    </b-form-group>

    <b-form-group
      id="input-group-address"
      label="Adresse"
      label-for="input-address">
      <b-form-input
        id="input-address"
        v-model="form.esta_address"
        type="text"
      />
    </b-form-group>

    <b-form-group
      id="input-group-city"
      label="Ville"
      label-for="input-city">
      <b-form-input
        id="input-city"
        v-model="form.esta_city"
        type="text"
      />
    </b-form-group>

    <b-form-group
      id="input-group-postalcode"
      label="Code Postal"
      label-for="input-postalcode">
      <b-form-input
        id="input-postalcode"
        v-model="form.esta_postalcode"
        type="number"
        maxlength ="5"
      />
    </b-form-group>

    <b-form-group
      id="input-group-country"
      label="Pays"
      label-for="input-country">
      <b-form-select
        id="input-country"
        v-model="form.esta_country"
        :options="countries"
      />
    </b-form-group>

    <b-form-group
      id="input-group-email"
      label="E-mail"
      label-for="input-email">
      <b-form-input
        id="input-email"
        v-model="form.esta_email"
        type="email"
      />
    </b-form-group>

    <b-form-group
      id="input-group-phone"
      label="Téléphone"
      label-for="input-phone">
      <b-form-input
        id="input-phone"
        v-model="form.esta_phone"
        type="number"
        maxlength ="10"
      />
    </b-form-group>

    <b-form-group id="input-group-check-internal">
      <b-form-checkbox
        id="checkbox-is_internal"
        v-model="form.esta_is_internal"
        :value="true"
        :unchecked-value="false">Interne</b-form-checkbox>
    </b-form-group>

    <b-form-group id="input-group-checks-enable">
      <b-form-checkbox
        id="checkbox-is_enable"
        v-model="form.esta_is_enable"
        :value="true"
        unchecked-value="false">Actif</b-form-checkbox>
    </b-form-group>

    <b-button
      type="submit"
      variant="primary">Enregistrer</b-button>
  </b-form>
</template>

<script>

import { getAllTag } from '../../services/tag'
import { getAllEstablishment, getEstablishmentById } from '../../services/establishment'

export default {
  name: 'FormEstablishment',
  props: {
    id: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      form: {
        esta_id: null,
        esta_internal_name: '',
        esta_name: '',
        esta_nice_name: '',
        parent_id: null,
        esta_address: '',
        esta_city: '',
        esta_postalcode: '',
        esta_country: '',
        esta_email: '',
        esta_phone: '',
        esta_is_internal: false,
        esta_is_enable: false,
        tags: [],
      },
      countries: ['France', 'Royaume-Uni', 'Espagne', 'Italie'],
      show: true,
      establishments: [],
      options: [],
    };
  },
  async mounted() {
    let params = {};
    if (this.id !== null) {
      params.estaId = this.id ;
    }
    const esta = await getAllEstablishment(params, true);
     if (esta) this.establishments = esta;
     const opts =  await getAllTag(true);
    if (opts) this.options = opts;

  },
  async created() {
    if (this.id !== null) {
      this.mapEstablishment(getEstablishmentById(this.id));
    }
  },
  methods: {
    mapEstablishment(data) {
      if (data) {
        this.form = data;
        this.form.parent_id = data.parent.esta_id;
        this.form.tags = data.tags.map(e => e.tag_id);
      }
    },
    onSubmit(evt) {
      evt.preventDefault();

      this.$emit('sendForm', JSON.stringify(this.form));
    },
  },
};
</script>

<style scoped>

</style>
